import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./WGRTable";
import { drawSummary } from "../pdfreport/drawSummary";
import { drawGrandTotal } from "./drawGrandTotalpdf";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"

export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);

  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



  // ==========================
  // Summary Page
  // ==========================

  doc.addPage();

  drawHeader(doc, month, year, title);


  drawGrandTotal(doc, grandTotal);


  drawSummary(doc, summary, grandTotal);

  // ==========================
  // Footer on every page
  // ==========================

  drawFooter(doc, month, year, title);
handlePdf(doc, PDF_ACTION.VIEW);
  //doc.save(`WGR_${month}_${year}.pdf`);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.SHOP ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          primeLabour: 0,
          primeStores: 0,
          onCostLabour: 0,
          onCostStores: 0,

        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.primeLabour += Number(row.PRIMECOST_LABOUR || 0);
    groups[shop].total.primeStores += Number(row.PRIMECOST_STORES || 0);
    groups[shop].total.onCostLabour += Number(row.ONCOST_LABOUR || 0);
    groups[shop].total.onCostStores += Number(row.ONCOST_STORES || 0);



    return groups;
  }, {});
}